import { BASE_COLS } from "./ViewsBar";

// All sheet columns (built-in + the tenant's own, not archived) in the tenant's saved order; new ones go at the end.
export function orderCols(fields, order) {
  const all = [...BASE_COLS.map(([key, label]) => ({ key, label })), ...fields.filter((f) => !f.archived).map((f) => ({ key: f.key, label: f.label, field: f }))];
  const pos = Object.fromEntries((order || []).map((k, i) => [k, i]));
  return all.map((c, i) => ({ ...c, i })).sort((a, b) => (pos[a.key] ?? 1000 + a.i) - (pos[b.key] ?? 1000 + b.i));
}
